import { render, staticRenderFns } from "./EmployeeGeneralDetailForm.vue?vue&type=template&id=24814193&scoped=true&"
import script from "./EmployeeGeneralDetailForm.vue?vue&type=script&lang=js&"
export * from "./EmployeeGeneralDetailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24814193",
  null
  
)

export default component.exports